/**
 * Per-instance activity fence. Consent revocation invalidates the old instance
 * before plugin cleanup runs, so delayed callbacks cannot become eligible
 * again merely because a later instance observes a fresh grant.
 */
export function createPluginActivityFence() {
  let active = true;
  return {
    isActive: () => active,
    deactivate: () => {
      active = false;
    },
  };
}
